import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/app/settings/communication')({
  beforeLoad: () => {
    throw redirect({ to: '/app/settings/mailbox', replace: true });
  },
});
